import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .react-datepicker-popper {
        z-index: 20;
    }
`;

export const ControlsCard = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 16px 20px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const FilterBox = styled.div`
    width: 360px;
`;

export const Actions = styled.div`
    display: flex;
    gap: 12px;
    margin-left: auto;
`;

export const FieldError = styled.div`
    color: ${colors.danger};
    font-size: 12px;
    line-height: 16px;
`;

export const RowActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const InlineField = styled.div`
    width: 100%;
    min-width: 220px;
`;
